
    import { Component, Vue } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import UntersuchungenDetail from '@/components/Untersuchungen/UntersuchungenDetail.vue';
    import Untersuchung from '@/types/Untersuchung';
    import { LoadUntersuchungenPayload, SetUntersuchungenDialogs, UntersuchungenFilter } from '@/store/untersuchungen';
    import { DataTableHeaders } from '@/types';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        components: {
            UntersuchungenDetail,
        },
        computed: {
            ...mapState('untersuchungen', ['untersuchungen', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('untersuchungen', ['loadUntersuchungen']),
            ...mapMutations('untersuchungen', ['setDialogs']),
        },
    })
    export default class Untersuchungen extends Vue {
        public loadUntersuchungen!: (payload?: LoadUntersuchungenPayload) => void;
        public setDialogs!: (dialogs: SetUntersuchungenDialogs) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public untersuchung = new Untersuchung();
        public search = '';

        public filter: UntersuchungenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Untersuchung> {
            if (this.getSystemEinstellung('muw').isEnabled()) {
                return [
                    {text: '', value: 'actions', sortable: false, width: 50},
                    {text: 'Code', value: 'code'},
                    {text: 'Untersuchung', value: 'untersuchung'},
                    {text: 'Einheit', value: 'einheit', width: 100},
                    {text: 'Befundvariante', value: 'untersuchungsbefundvariante_bezeichnung'},
                    {text: 'Preis', value: 'preis'},
                    {text: 'Preis Mitarbeiter', value: 'preis_mitarbeiter'},
                    {text: 'Preis Rektorat', value: 'preis_rektorat'},
                    {text: 'Steuersatz', value: 'steuersatz'},
                    {text: 'HCW', value: 'hcw'},
                    {text: 'Kassenleistung', value: 'kassenleistung'},
                    {text: 'Verrechnung', value: 'verrechnung'},
                    {text: 'Sortierung', value: 'sort'},
                    {text: 'Automatisch auswählen', value: 'select_by_default'},
                    {text: 'Gültig', value: 'gueltig'},
                ];
            } else {
                return [
                    {text: '', value: 'actions', sortable: false, width: 50},
                    {text: 'Code', value: 'code'},
                    {text: 'Untersuchung', value: 'untersuchung'},
                    {text: 'Einheit', value: 'einheit', width: 100},
                    {text: 'Befundvariante', value: 'untersuchungsbefundvariante_bezeichnung'},
                    {text: 'Preis', value: 'preis'},
                    {text: 'Steuersatz', value: 'steuersatz'},
                    {text: 'Verrechnung', value: 'verrechnung'},
                    {text: 'Sortierung', value: 'sort'},
                    {text: 'Automatisch auswählen', value: 'select_by_default'},
                    {text: 'Gültig', value: 'gueltig'},
                ];
            }
        }

        public mounted(): void {
            this.loadUntersuchungen({ filter: this.filter });
        }

        public onChangeFilter(): void {
            this.loadUntersuchungen({ filter: this.filter });
        }

        public onClickEdit(untersuchung: Untersuchung): void {
            this.untersuchung = new Untersuchung(untersuchung);
            this.setDialogs({ edit: true });
        }

        public onClickNew(): void {
            this.untersuchung = new Untersuchung();
            this.setDialogs({ edit: true });
        }
    }
